import React, { useState, useEffect, useCallback, useMemo, useContext} from 'react';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { useDropzone } from 'react-dropzone';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config.js';
import {v4 as uuidv4} from 'uuid';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import useNotification from '../../../hooks/useNotification';

const baseStyle = {
    //flex: 1,
    width: '230px',
    height: '90px',
    //marginLeft: '50px',
    display: 'flex',
    fontSize: '14px',
    flexDirection: 'column',
    alignItems: 'center',

    //padding: '50px',
    borderWidth: 3,
    borderRadius: 5,
    borderColor: '#aaaaaa',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};
function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function ManageBannersDialog(props) {
    const auth = useContext(AuthContext);
    const { notificationSuccess, notificationError, notificationInfo } = useNotification();
    const [dialogMode, setDialogMode] = useState('');

    const [idEntita, setIdEntita] = useState('');
    const [city, setCity] = useState('');

    const [radioValue, setRadioValue] = useState('0');

    const [descrizione, setDescrizione] = useState('');
    const [itbigimg, setItbigimg] = useState('');
    const [itsmallimg, setItsmallimg] = useState('');
    const [enbigimg, setEnbigimg] = useState('');
    const [ensmallimg, setEnsmallimg] = useState('');
    const [flagDefault, setFlagDefault] = useState('');

    const [itbigimgLink, setItbigimgLink] = useState('');
    const [itsmallimgLink, setItsmallimgLink] = useState('');
    const [enbigimgLink, setEnbigimgLink] = useState('');
    const [ensmallimgLink, setEnsmallimgLink] = useState('');

    const [originalDescrizione, setOriginalDescrizione] = useState('');
    const [originalItbigimg, setOriginalItbigimg] = useState('');
    const [originalItsmallimg, setOriginalItsmallimg] = useState('');
    const [originalEnbigimg, setOriginalEnbigimg] = useState('');
    const [originalEnsmallimg, setOriginalEnsmallimg] = useState('');
    const [originalFlagDefault, setOriginalFlagDefault] = useState('');

    const [originalItbigimgLink, setOriginalItbigimgLink] = useState('');
    const [originalItsmallimgLink, setOriginalItsmallimgLink] = useState('');
    const [originalEnbigimgLink, setOriginalEnbigimgLink] = useState('');
    const [originalEnsmallimgLink, setOriginalEnsmallimgLink] = useState('');

    useEffect(() => {
        async function init(){
            if(props.openManageBannersDialog==='mod'){
                setIdEntita(props.lastCellData?.idEntita.S);
                setCity(props.lastCellData?.city.S);
                setDialogMode('mod');
                getBanner(props.lastCellData?.idEntita.S, props.lastCellData?.city.S);
            }else{
                setIdEntita('');
                setCity('');
                setDialogMode('ins');

                setDescrizione('');
                setItbigimg('');
                setItsmallimg('');
                setEnbigimg('');
                setEnsmallimg('');
                setFlagDefault('');
                setItbigimgLink('');
                setItsmallimgLink('');
                setEnbigimgLink('');
                setEnsmallimgLink('');

                setOriginalDescrizione('');
                setOriginalItbigimg('');
                setOriginalItsmallimg('');
                setOriginalEnbigimg('');
                setOriginalEnsmallimg('');
                setOriginalFlagDefault('');
                setOriginalItbigimgLink('');
                setOriginalItsmallimgLink('');
                setOriginalEnbigimgLink('');
                setOriginalEnsmallimgLink('');
            }
        }
        init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.openManageBannersDialog])

    const getBanner = async(forcePassId = false, forcePassCity = false) => {
        try {
            const params = {
                idEntita: forcePassId ? forcePassId : idEntita,
                city: forcePassCity ? forcePassCity : city
            };

            const axiosParams = {
                url: '/get-banner',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);

            let itemData = response.data.result.Item;

            setDescrizione(itemData?.descrizione?.S || '');
            setItbigimg(itemData?.itbigimg?.S || '');
            setItsmallimg(itemData?.itsmallimg?.S || '');
            setEnbigimg(itemData?.enbigimg?.S || '');
            setEnsmallimg(itemData?.ensmallimg?.S || '');
            setFlagDefault(itemData?.flagDefault?.S || '');

            setItbigimgLink(itemData?.itbigimgLink?.S || '');
            setItsmallimgLink(itemData?.itsmallimgLink?.S || '');
            setEnbigimgLink(itemData?.enbigimgLink?.S || '');
            setEnsmallimgLink(itemData?.ensmallimgLink?.S || '');

            setOriginalDescrizione(itemData?.descrizione?.S || '');
            setOriginalItbigimg(itemData?.itbigimg?.S || '');
            setOriginalItsmallimg(itemData?.itsmallimg?.S || '');
            setOriginalEnbigimg(itemData?.enbigimg?.S || '');
            setOriginalEnsmallimg(itemData?.ensmallimg?.S || '');
            setOriginalFlagDefault(itemData?.flagDefault?.S || '');
    
            setOriginalItbigimgLink(itemData?.itbigimgLink?.S || '');
            setOriginalItsmallimgLink(itemData?.itsmallimgLink?.S || '');
            setOriginalEnbigimgLink(itemData?.enbigimgLink?.S || '');
            setOriginalEnsmallimgLink(itemData?.ensmallimgLink?.S || '');
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const modBanner = async() => {
        try {
            const essentialData = {
                idEntita: idEntita,
                city: city
            }

            let isFlagDefaultChanged = flagDefault === originalFlagDefault ? false : true;

            const data = {
                descrizione: descrizione === originalDescrizione ? '' : descrizione,
                flagDefault: flagDefault === originalFlagDefault ? '' : flagDefault,

                itbigimgLink: itbigimgLink === originalItbigimgLink ? '' : itbigimgLink,
                itsmallimgLink: itsmallimgLink === originalItsmallimgLink ? '' : itsmallimgLink,
                enbigimgLink: enbigimgLink === originalEnbigimgLink ? '' : enbigimgLink, 
                ensmallimgLink: ensmallimgLink === originalEnsmallimgLink ? '' : ensmallimgLink
            }

            const dataToPass = {
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length && itbigimg === originalItbigimg && itsmallimg === originalItsmallimg && enbigimg === originalEnbigimg && ensmallimg === originalEnsmallimg){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }
            let form = new FormData();

            form.append('essentialData', JSON.stringify(essentialData));
            
            if(itbigimg !== originalItbigimg){
                form.append('file', itbigimg);
            }
            if(itsmallimg !== originalItsmallimg){
                form.append('file', itsmallimg);
            }
            if(enbigimg !== originalEnbigimg){
                form.append('file', enbigimg);
            }
            if(ensmallimg !== originalEnsmallimg){
                form.append('file', ensmallimg);
            }

            if(Object.keys(data).length){
                form.append('data', JSON.stringify(dataToPass))
            }

            const axiosParams = {
                url: '/mod-banner',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: form
            };
            const response = await axios(axiosParams);
            notificationSuccess('banner Aggiornato');

            let newOriginalItems = response.data.responseUpdate.Attributes

            setOriginalDescrizione(newOriginalItems?.descrizione?.S || '');
            setOriginalFlagDefault(newOriginalItems?.flagDefault?.S || '');

            setOriginalItbigimg(newOriginalItems?.itbigimg?.S || '');
            setOriginalItsmallimg(newOriginalItems?.itsmallimg?.S || '');
            setOriginalEnbigimg(newOriginalItems?.enbigimg?.S || '');
            setOriginalEnsmallimg(newOriginalItems?.ensmallimg?.S || '');

            setOriginalItbigimgLink(newOriginalItems?.itbigimgLink?.S || '');
            setOriginalItsmallimgLink(newOriginalItems?.itsmallimgLink?.S || '');
            setOriginalEnbigimgLink(newOriginalItems?.enbigimgLink?.S || '');
            setOriginalEnsmallimgLink(newOriginalItems?.ensmallimgLink?.S || '');
            //per l'immagine devo resettare anche il corrente siccome il datatype è diverso
            setItbigimg(newOriginalItems?.itbigimg?.S || '');
            setItsmallimg(newOriginalItems?.itsmallimg?.S || '');
            setEnbigimg(newOriginalItems?.enbigimg?.S || '');
            setEnsmallimg(newOriginalItems?.ensmallimg?.S || '');

            props.getBanners(isFlagDefaultChanged, idEntita);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const insBanner = async () => {
        try {
            let newIdEntita = uuidv4();
            const essentialData = {
                idEntita: newIdEntita,
            }
            let isFlagDefaultFlagged = flagDefault === 'Y' ? true : false;
            const data = {
                descrizione: descrizione,
                flagDefault: flagDefault,
                itbigimgLink: itbigimgLink,
                itsmallimgLink: itsmallimgLink,
                enbigimgLink: enbigimgLink, 
                ensmallimgLink: ensmallimgLink,
                city: props.city
            }

            let form = new FormData();

            form.append('essentialData', JSON.stringify(essentialData));

            if(itbigimg !== originalItbigimg){
                form.append('file', itbigimg);
            }
            if(itsmallimg !== originalItsmallimg){
                form.append('file', itsmallimg);
            }
            if(enbigimg !== originalEnbigimg){
                form.append('file', enbigimg);
            }
            if(ensmallimg !== originalEnsmallimg){
                form.append('file', ensmallimg);
            }

            if(Object.keys(data).length){
                form.append('data', JSON.stringify(data))
            }

            const axiosParams = {
                url: '/ins-banner',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: form
            };

            await axios(axiosParams);
            notificationSuccess('Banner Aggiunto');
            
            setIdEntita(newIdEntita);
            setCity(props.city);
            setDialogMode('mod');

            await props.getBanners(isFlagDefaultFlagged, newIdEntita);
            await getBanner(newIdEntita, props.city);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const onDrop = useCallback(async(acceptedFiles) => {
        //devo prendere il file e renderlo base64 per poi storarlo
        if(acceptedFiles.length===0){
            notificationInfo('Sono accette solo immagini in formato .jpg');
            return;
        }
        if(radioValue === "0"){
            const renamedAcceptedFiles = acceptedFiles.map((file) => (
                new File([file], `itbigimg`, { type: file.type })
            ))
            setItbigimg(renamedAcceptedFiles[0])
        }else if(radioValue === "1"){
            const renamedAcceptedFiles = acceptedFiles.map((file) => (
                new File([file], `itsmallimg`, { type: file.type })
            ))
            setItsmallimg(renamedAcceptedFiles[0])
        }else if(radioValue === "2"){
            const renamedAcceptedFiles = acceptedFiles.map((file) => (
                new File([file], `enbigimg`, { type: file.type })
            ))
            setEnbigimg(renamedAcceptedFiles[0])
        }else if(radioValue === "3"){
            const renamedAcceptedFiles = acceptedFiles.map((file) => (
                new File([file], `ensmallimg`, { type: file.type })
            ))
            setEnsmallimg(renamedAcceptedFiles[0])
        }
        
    }, [radioValue]);

    const {
        /* acceptedFiles, */
        getRootProps,
        getInputProps,
        open,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({onDrop, accept: {'image/jpeg':['.jpg'] },  multiple: false/* , maxFiles: 1, maxSize: 31457280 */});

    const dropZonestyle = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    return (
        <Dialog className="dialog-mod-banner" open={props.openManageBannersDialog} onClose={props.handleCloseManageBannersDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{dialogMode === 'ins' ? 'Inserisci banner' : originalDescrizione}</DialogTitle>
            <DialogContent>
                <div className='dialog-banner-wrapper'>
                    <div className='dialog-banner-wrapper-fields'>
                        <div className="dialog-banner-fields">
                            <TextField
                                className="dialog-descrizione required-field-bg"
                                id="dialog-descrizione"
                                label="Descrizione"
                                type="text"
                                value={descrizione}
                                onChange={(event) => {
                                    setDescrizione(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                                inputProps={{
                                    maxLength: 50
                                }}
                            />
                            
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={originalFlagDefault === 'Y' ? true : false}
                                        checked={flagDefault === 'Y' ? true : false}
                                        onChange={(event) => setFlagDefault(event.target.checked ? 'Y' : 'N')}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                }
                                label="Default"
                            />
                        </div>
                        <Divider variant="middle" style={{margin: '10px 0'}}/>
                        {(dialogMode==='mod')&&(
                        <div className="dialog-banner-wrapper-section">
                            <div className="dialog-banner-fields">
                            <FormControl>
                                <FormLabel id="images-radio-buttons-group">Immagine</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="images-radio-buttons-group"
                                    name="controlled-images-radio-buttons-group"
                                    value={radioValue}
                                    onChange={(event) => setRadioValue(event.target.value)}
                                >
                                    <FormControlLabel value="0" control={<Radio size="small"/>} label="It-Grande" />
                                    <FormControlLabel value="1" control={<Radio size="small"/>} label="It-Piccola" />
                                    <FormControlLabel value="2" control={<Radio size="small"/>} label="En-Grande" />
                                    <FormControlLabel value="3" control={<Radio size="small"/>} label="En-Piccola" />
                                </RadioGroup>
                            </FormControl>
                            <div className="dropBox" {...getRootProps({style: dropZonestyle})}>
                                <input {...getInputProps()} />
                                <p style={{textAlign: "center"}}>Clicca per caricare l'immagine</p>
                                <p style={{textAlign: "center"}}>Oppure trascina qui</p>
                            </div>
                        </div>
                        <div className="dialog-banner-fields spaced-for-imgs">
                            <div className="dialog-banner-wrapper-section">
                                <span>IT</span>
                                <img width="200" height="100" alt='big-it' src={originalItbigimg !== itbigimg ? URL.createObjectURL(itbigimg) : 'data:image/jpg;base64, '+originalItbigimg}/>
                                <TextField
                                    className="dialog-link"
                                    id="dialog-link-itBig"
                                    label="Link Grande"
                                    type="text"
                                    value={itbigimgLink}
                                    onChange={(event) => {
                                        setItbigimgLink(event.target.value);
                                    }}
                                    variant="standard"
                                    style={{
                                        width: "100%"
                                    }}
                                />
                                <img width="200" height="100" alt='small-it' src={originalItsmallimg !== itsmallimg ? URL.createObjectURL(itsmallimg) : 'data:image/jpg;base64, '+originalItsmallimg}/>
                                <TextField
                                    className="dialog-link"
                                    id="dialog-link-itSmall"
                                    label="Link Piccola"
                                    type="text"
                                    value={itsmallimgLink}
                                    onChange={(event) => {
                                        setItsmallimgLink(event.target.value);
                                    }}
                                    variant="standard"
                                    style={{
                                        width: "100%"
                                    }}
                                />
                            </div>
                            <div className="dialog-banner-wrapper-section">
                                <span>EN</span>
                                <img width="200" height="100" alt='big-en' src={originalEnbigimg !== enbigimg ? URL.createObjectURL(enbigimg) : 'data:image/jpg;base64, '+originalEnbigimg}/>
                                <TextField
                                    className="dialog-link"
                                    id="dialog-link-enBig"
                                    label="Link Grande"
                                    type="text"
                                    value={enbigimgLink}
                                    onChange={(event) => {
                                        setEnbigimgLink(event.target.value);
                                    }}
                                    variant="standard"
                                    style={{
                                        width: "100%"
                                    }}
                                />
                                <img width="200" height="100" alt='small-en' src={originalEnsmallimg !== ensmallimg ? URL.createObjectURL(ensmallimg) : 'data:image/jpg;base64, '+originalEnsmallimg}/>
                                <TextField
                                    className="dialog-link"
                                    id="dialog-link-enSmall"
                                    label="Link Piccola"
                                    type="text"
                                    value={ensmallimgLink}
                                    onChange={(event) => {
                                        setEnsmallimgLink(event.target.value);
                                    }}
                                    variant="standard"
                                    style={{
                                        width: "100%"
                                    }}
                                />
                            </div>
                        </div>
                    </div>)}
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={() => dialogMode === 'ins' ? insBanner() : modBanner()}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseManageBannersDialog}>
                    Esci
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ManageBannersDialog